export default __webpack_public_path__ + "static/media/depth.57cac15e.png";